import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../api";
import RedStar from "../../../common/RedStar";
export default function BankInfoDialog(props) {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [relatedBrandList, setRelatedBrandList] = useState([]);
  const [procode, setProCode] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categoryLists, setCategoryLists] = useState([]);
  const [subCategoryLists, setSubCategoryLists] = useState([]);
  const [relatedBrand, setRelatedBrand] = useState("");
  const [description, setDescription] = useState("");

  const [errors, setErrors] = useState({
    procode: "",
    name: "",
    category: "",
    subCategory: "",
    relatedBrand: "",
    description: "",
  });

  const ProMedicineCreate = () => {
    const require = {};
    if (!name) {
      require.name = "Name is required";
    }
    if (!procode) {
      require.procode = "Procedure Code is required";
    }
    if (!category) {
      require.category = "Category is required";
    }
    if (!subCategory) {
      require.subCategory = "Sub Category is required";
    }
    if (!relatedBrand) {
      require.relatedBrand = "Brand is required";
    }
    if (Object.keys(require).length > 0) {
      setErrors(require);
      return;
    }

    setErrors({
      procode: "",
      name: "",
      category: "",
      subCategory: "",
      relatedBrand: "",
      description: "",
    });

    const data = {
      name: name,
      code: procode,
      relatedCategory: category,
      relatedSubCategory: subCategory,
      relatedBrand: relatedBrand,
      description: description,
    };

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api.post("procedure-medicine", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "Procedure Medicine Created Successfully!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });

      props.setProMedicineLists([
        ...props.proMedicineLists,
        response.data.data,
      ]);
    });
    props.close();
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await api.get("categories");

        setCategoryLists(res.data.data);
      } catch (err) {}
    };
    const getSubCategory = async () => {
      try {
        const res = await api.get("sub-categories");

        setSubCategoryLists(res.data.data);
      } catch (err) {}
    };

    const getBrandLists = async () => {
      try {
        const res = await api.get("brands");
        setRelatedBrandList(res.data.data);
      } catch (err) {
        alert(err.message);
      }
    };
    getCategory();
    getSubCategory();

    getBrandLists();
  }, []);

  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle>
          {" "}
          <div className="modal-header bg-info">
            <h4 className="modal-title">Create New Procedure Medicine</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class="modal-body">
            <div class="form-group">
              <label for="name">
                Code <RedStar />
              </label>
              <input
                type="text"
                class="form-control border border-info"
                name="code"
                onChange={(e) => setProCode(e.target.value)}
              />
              {errors?.procode && (
                <div className="text-danger">{errors?.procode}</div>
              )}
            </div>
            <div class="form-group">
              <label for="name">
                Name <RedStar />
              </label>
              <input
                type="text"
                class="form-control border border-info"
                name="name"
                placeholder="eg. mg mg"
                onChange={(e) => setName(e.target.value)}
              />
              {errors?.name && (
                <div className="text-danger">{errors?.name}</div>
              )}
            </div>
            <div class="form-group">
              <label for="name">
                Category <RedStar />
              </label>
              <select
                class="custom-select border-info"
                name="account_type_id"
                id="cat"
                onChange={(e) => setCategory(e.target.value)}
              >
                <option hidden>Choose Category</option>
                {categoryLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {errors?.category && (
                <div className="text-danger">{errors?.category}</div>
              )}
            </div>
            <div class="form-group">
              <label for="name">
                Sub Category <RedStar />
              </label>
              <select
                class="custom-select border-info"
                id="subCat"
                name="account_type_id"
                onChange={(e) => setSubCategory(e.target.value)}
              >
                <option hidden>Choose Sub Category</option>
                {subCategoryLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {errors?.subCategory && (
                <div className="text-danger">{errors?.subCategory}</div>
              )}
            </div>

            <div class="form-group">
              <label for="name">
                Choose Brand <RedStar />
              </label>
              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={(e) => setRelatedBrand(e.target.value)}
              >
                <option hidden>Choose Brand</option>

                {relatedBrandList.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {errors?.relatedBrand && (
                <div className="text-danger">{errors?.relatedBrand}</div>
              )}
            </div>
            <div class="form-group">
              <label for="name">Description</label>
              <textarea
                className="form-control"
                id="description"
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <Button
              class="btn btn-secondary"
              data-dismiss="modal"
              onClick={props.close}
            >
              Close
            </Button>
            <Button class="btn btn-primary" onClick={ProMedicineCreate}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
